import { miniApp } from "@telegram-apps/sdk-react"
import { clearTelegramData } from "./store"

export const closeMiniApp = (): void => {
	clearTelegramData()
	miniApp.close.ifAvailable()
}

export const isMiniAppActive = (): boolean | null => {
	try {
		if (miniApp.isMounted()) {
			return miniApp.isActive()
		}
	} catch {
		// SDK not available
	}
	return null
}

export const onMiniAppActiveChange = (
	callback: (isActive: boolean) => void,
): (() => void) | null => {
	try {
		if (miniApp.isMounted()) {
			return miniApp.isActive.sub(callback)
		}
	} catch {
		// SDK not available
	}
	return null
}
